import btnStyle from '@/components/Shares/Button.module.css';
import { Icons } from '@/components/Shares/Icons';
import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { ActionIcon, AspectRatio, Box, Flex, Group, Image, Paper, Stack, Text, Tooltip, rem } from '@mantine/core';
import { useFullscreen } from '@mantine/hooks';
import { PrimeSwitch } from '../Shares/PrimeSwitch';
export const GameView: React.FC = () => {
  const {
    i18n
  } = useLingui();
  const {
    setOpenModal
  } = useModalAction();
  const {
    ref,
    toggle,
    fullscreen
  } = useFullscreen();
  return <Paper radius={5} bg="var(--bg-200)" ref={ref}>
      <Stack gap={0} justify="center">
        <Group justify="space-between" px={{
        base: 10,
        sm: 16,
        lg: 20
      }} py={{
        base: 20,
        lg: 37
      }}>
          <Box>
            <Text fz={{
            base: rem(14),
            lg: rem(20)
          }} c="var(--text-dark)" className={gunterzBold.className}>
              {i18n._('Sweet bonanza')}
            </Text>
            <Text fz={{
            base: rem(10),
            lg: rem(14)
          }} tt="uppercase" c="var(--text-dark)" fw={700}>
              {i18n._('Pragmatic Play')}
            </Text>
          </Box>

          <Group gap={10}>
            <Icons className="icon-pr-flat-gaming" fontSize={24} />
            <Text tt="uppercase" fz="xs" c="var(--text-dark)" fw={700}>
              {i18n._('Fun Play')}
            </Text>
            <PrimeSwitch />
            {fullscreen && <ActionIcon onClick={toggle}>
                <Icons className="icon-pr-line-close" />
              </ActionIcon>}
          </Group>
        </Group>

        <AspectRatio ratio={16 / 9} bg="var(--bg-100)">
          <Image src="/assets/game-view.png" alt="games" w="90%" mah={823} mx="auto" fit="contain" />
        </AspectRatio>

        <Group justify="space-between" p={{
        base: 10,
        sm: 16,
        lg: 20
      }}>
          <Flex gap={{
          base: 8,
          sm: 10,
          lg: 16
        }}>
            <ActionIcon size="xl" classNames={{
            root: btnStyle.btnIcon
          }} onClick={toggle}>
              <Icons className="icon-pr-line-expand" fontSize={24} />
            </ActionIcon>
            <Tooltip withArrow color="var(--text-dark)" c="dark" fz="xs" arrowSize={8} label={i18n._('Live Game Stats')} transitionProps={{
            transition: 'fade-up',
            duration: 300
          }}>
              <ActionIcon size="xl" classNames={{
              root: btnStyle.btnIcon
            }}>
                <Icons className="icon-pr-line-chart-up" fontSize={24} />
              </ActionIcon>
            </Tooltip>
          </Flex>

          <Flex gap={{
          base: 8,
          sm: 10,
          lg: 16
        }}>
            <ActionIcon size="xl" classNames={{
            root: btnStyle.btnIcon
          }}>
              <Icons className="icon-pr-line-heart" fontSize={24} />
            </ActionIcon>
            <ActionIcon size="xl" classNames={{
            root: btnStyle.btnIcon
          }} onClick={() => setOpenModal(MODAL.SHARE)}>
              <Icons className="icon-pr-line-share" fontSize={24} />
            </ActionIcon>
          </Flex>
        </Group>
      </Stack>
    </Paper>;
};